import { call, put, select, takeLatest } from "redux-saga/effects";

import type {
  FiWeeklySummaryRequest,
  FiWeeklySummaryResponse,
} from "@mapmycustomers/shared/types/entity/fieldInsight";
import type Organization from "@mapmycustomers/shared/types/Organization";

import { getDatesRange } from "@app/enum/dashboard/dateRanges";
import scopeToFilter from "@app/scene/dashboard/utils/scopeToFilter";
import { callApi } from "@app/store/api/callApi";
import { handleError } from "@app/store/errors/actions";
import { getOrganizationId } from "@app/store/iam/selectors";
import { formatDate } from "@app/util/formatters";

import { fetchWeeklySummaryData } from "./actions";

function* onFetchWeeklySummaryData({ payload }: ReturnType<typeof fetchWeeklySummaryData>) {
  try {
    const orgId: Organization["id"] = yield select(getOrganizationId);
    const { endDate, startDate } =
      payload.customRange ?? getDatesRange(payload.dateRange.range, payload.dateRange.subRange);

    const request: FiWeeklySummaryRequest = {
      endDate: formatDate(endDate, "yyyy-MM-dd"),
      startDate: formatDate(startDate, "yyyy-MM-dd"),
      ...(payload.scope ? scopeToFilter(payload.scope) : {}),
      ...(payload.forceRefresh ? { forceRefresh: true } : {}),
    };

    const response: FiWeeklySummaryResponse = yield callApi(
      "fetchFieldInsightsWeeklySummary",
      orgId,
      request
    );
    yield call(payload.callback, response);
  } catch (error) {
    yield put(handleError({ error }));
    if (payload.failureCallback) {
      yield call(payload.failureCallback);
    }
  }
}

export function* weeklySummarySagas() {
  yield takeLatest(fetchWeeklySummaryData, onFetchWeeklySummaryData);
}
